const API_URL = 'https://api.openweathermap.org/data/2.5'

export default API_URL
